import NavPopper from './src/nav-popper';

NavPopper.directive = NavPopper.component.Popper.directive;

export default NavPopper;
